var _defs, _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReactjsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00d7ff;}.cls-2{fill:none;stroke:#00d7ff;stroke-miterlimit:10;stroke-width:16.06px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 250.01,
    cy: 249.68,
    r: 33.58,
    transform: "translate(-36.5 456.47) rotate(-80.78)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m250.01,181.41c45.08,0,86.96,6.47,118.53,17.33,38.04,13.09,61.43,32.95,61.43,50.92s-24.79,39.83-65.64,53.36c-30.88,10.23-71.53,15.58-114.32,15.58s-85.41-5.02-116.65-15.69c-39.52-13.51-63.32-34.87-63.32-53.24s22.34-37.53,59.85-50.6c31.69-11.04,74.61-17.66,120.13-17.66h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m190.58,215.75c22.52-39.05,49.05-72.1,74.24-94.01,30.35-26.41,59.24-36.75,74.81-27.78,16.22,9.35,22.12,41.37,13.43,83.53-6.57,31.87-22.24,69.75-43.62,106.82-21.92,38.01-47.02,71.49-71.87,93.22-31.44,27.49-61.84,37.43-77.76,28.25-15.45-8.91-21.35-38.1-13.95-77.13,6.26-33,21.97-73.47,44.72-112.9h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m190.64,284.38c-22.58-39.02-37.96-78.5-44.38-111.27-7.72-39.48-2.26-69.68,13.29-78.68,16.21-9.39,46.89,1.5,79.07,30.07,24.34,21.61,49.32,54.1,70.76,91.14,21.98,37.97,38.46,76.44,44.87,108.81,8.11,40.97,1.54,72.28-14.36,81.48-15.44,8.93-43.67-.52-73.78-26.43-25.43-21.89-52.66-55.72-75.46-95.11h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactjsIcon);
export default __webpack_public_path__ + "static/media/reactjs_icon.213e4b069177f6f861736482b42ae210.svg";
export { ForwardRef as ReactComponent };